module.exports = __webpack_public_path__ + "img/02.08d78ffa.jpg";